import { createSelector } from 'reselect';

import { initialState } from './reducer';
import {
  CONSENT_NAMES_TO_SEND,
  CONSENT_PAGE_HEADER_SSO,
  CONSENT_PAGE_HEADER_SSO_MOBILE,
  CONSENT_SECONDARY_BUTTON_LABEL,
  CONSENT_SUBMIT_LABEL,
  FORM_CONSENT,
  STATUS_CONSENT,
} from '../../Main/constants';
import makeSelectMain, {
  getMainClientInfo,
  getError as getMainError,
  selectMainStatus,
} from '../../Main/selectors';
import makeSelectMobile from '../../Mobile/selectors';
import { interpolate } from '../../../utils/globalHelpers';

/**
 * Direct selector to the SSO Consent state domain
 */
const selectSsoConsentDomain = (state) => state.ssoConsent || initialState;

/**
 * @description Selects consents user agreed to
 */
const getSsoConsentsAgreed = () => createSelector(
  getSsoConsentForm(FORM_CONSENT),
  (inputs) => Object.keys(inputs)
    .filter((key) => inputs[key])
    .map((consent) => CONSENT_NAMES_TO_SEND[consent])
    .join(','),
);

/**
 * @description Selects all inputs for a given prop
 */
const getSsoConsentForm = (prop) => createSelector(
  makeSelectSsoConsent('forms'),
  (forms) => forms[prop],
);

/**
 * @description Selects props for the consent form for SSO flow
 */
const getSsoConsentFormProps = () => createSelector(
  getSsoConsentsAgreed(),
  makeSelectSsoConsent('consentsNeeded'),
  getMainError('main'),
  selectMainStatus(STATUS_CONSENT),
  makeSelectMain('success'),
  getSsoConsentForm(FORM_CONSENT),
  getMainClientInfo('customerServicePhoneNumber'),
  makeSelectMobile('isMobile'),
  (
    consentsAgreed,
    consentsNeeded,
    error,
    status,
    success,
    formValues,
    customerServicePhoneNumber,
    isMobile,
  ) => ({
    consentsAgreed,
    consentsNeeded,
    error: error ? interpolate(error, { customerServicePhoneNumber }) : '',
    formName: FORM_CONSENT,
    formValues,
    pageHeader: isMobile ? CONSENT_PAGE_HEADER_SSO_MOBILE : CONSENT_PAGE_HEADER_SSO,
    secondaryButtonLabel: CONSENT_SECONDARY_BUTTON_LABEL,
    status,
    submitLabel: CONSENT_SUBMIT_LABEL,
    success,
  }),
);

/**
 * Default selector used by SSO Consent
 */
const makeSelectSsoConsent = (prop) => createSelector(
  selectSsoConsentDomain,
  (state) => state[prop],
);

export default makeSelectSsoConsent;
export {
  getSsoConsentsAgreed,
  getSsoConsentForm,
  getSsoConsentFormProps,
  makeSelectSsoConsent,
};
